type GetNameForShowType = {
  firstName: string | null;
  lastName: string | null;
  userName: string | null;
};

const getNameForShow = ({
  firstName,
  lastName,
  userName,
}: GetNameForShowType): string => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (firstName) {
    return firstName;
  }

  if (lastName) {
    return lastName;
  }

  if (userName) {
    return userName;
  } else {
    return '';
  }
};

export { getNameForShow };
